const plusIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="11" y="16" width="2" height="12" transform="rotate(-180 11 16)" fill="white"/>
<rect x="16" y="9" width="2" height="12" transform="rotate(90 16 9)" fill="white"/>
</svg>
`;

export default plusIcon;
